/*
 * https://www.npmjs.com/package/react-paginate#props
 * use props to style
 */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */

import React, { ReactElement, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";

import { MenuPlacement } from "react-select";
import { useTranslation } from "react-i18next";
import { SelectComponent } from "components/Novus/Select";
import { ReactPaginateStyle, TableFooterPaginationStyles } from "./styles";
import ThreedotImg from "../../../assets/three-dots.svg";
import RightArrow from "../../../assets/rightArrow.svg";
import { TableInfo } from "../Table/styles";

export interface OptionsProps {
    label: number;
    value: number;
}

// Send all props - TODO
interface Props {
    changePageSize?: (arg0: number) => void;
    marginPagesDisplayed: number;
    pageRangeDisplayed: number;
    rowsPerPage: number;
    totalCount: number;
    pageNumber: number;
    selectedCount?: number;
    activeClassName?: string;
    className?: string;
    containerClassName?: string;
    handlePagination?: (selectedItem: { selected: number }, arg1?: number) => void;
    breakClassName?: string;
    breakLinkClassName?: string;
    pageClassName?: string;
    pageLinkClassName?: string;
    previousClassName?: string;
    previousLinkClassName?: string;
    nextLinkClassName?: string;
    nextClassName?: string;
    disabledClassName?: string;
    initialPageIndex?: number;
    menuPlacement?: MenuPlacement;
    hideRowsPerPageBar?: boolean;
    hideSelectedRowsText?: boolean;
    hidePageLengthChangeDropdown?: boolean;
    pageLengthChangeDropdownOptions?: Array<OptionsProps>;
}

export const PaginationComponent = ({
    activeClassName,
    containerClassName,
    changePageSize,
    totalCount,
    selectedCount,
    rowsPerPage,
    handlePagination,
    pageNumber,
    breakClassName,
    breakLinkClassName,
    pageClassName,
    pageLinkClassName,
    previousClassName,
    previousLinkClassName,
    nextLinkClassName,
    nextClassName,
    disabledClassName,
    marginPagesDisplayed,
    pageRangeDisplayed,
    hideRowsPerPageBar,
    hideSelectedRowsText,
    hidePageLengthChangeDropdown,
    pageLengthChangeDropdownOptions
}: Props): ReactElement | null => {
    const { t } = useTranslation();

    const [offset, changeOffset] = useState(pageNumber || 0);

    useEffect(() => {
        changeOffset(pageNumber);
    }, [pageNumber]);

    if (totalCount >= rowsPerPage) {
        return (
            <TableFooterPaginationStyles>
                <div className="pagination-details">
                    {!hidePageLengthChangeDropdown && (
                        <div
                            className="select-pages"
                            data-toggle="tooltip"
                            title={rowsPerPage.toString()}
                        >
                            <SelectComponent
                                menuPlacement="top"
                                options={pageLengthChangeDropdownOptions}
                                value={{
                                    label: rowsPerPage,
                                    value: rowsPerPage
                                }}
                                onChange={(val): void => {
                                    const option = val as OptionsProps;
                                    const { value } = option;

                                    if (changePageSize) {
                                        changePageSize(value);
                                    }

                                    if (handlePagination) {
                                        handlePagination({ selected: 0 }, value);
                                        changeOffset(0);
                                    }
                                }}
                            />
                        </div>
                    )}
                    <div className="pagination-content">
                        {!hideRowsPerPageBar && (
                            <>
                                <div>{`${t("Rows per page")}: ${rowsPerPage},`}</div>
                                {/* <div>
                                    {`${offset * rowsPerPage}-${Math.min(
                                        (offset + 1) * rowsPerPage,
                                        totalCount
                                    )} ${t("of")} ${totalCount}`}
                                </div> */}
                            </>
                        )}
                        {!hideSelectedRowsText && (
                            <div>
                                <span>{`${t("Selected")}: ${selectedCount}`}</span>
                                <span>{`${t(" of ")} ${totalCount}`}</span>
                            </div>
                        )}
                    </div>
                </div>
                <ReactPaginateStyle>
                    <ReactPaginate
                        activeClassName={`${activeClassName ? ` ${activeClassName}` : ""}`}
                        breakLabel={
                            <span className="d-flex align-self-end">
                                <img
                                    alt="dots"
                                    className="breakLabel"
                                    height="100%"
                                    src={ThreedotImg}
                                    width="19"
                                />
                            </span>
                        }
                        containerClassName={`${containerClassName ? ` ${containerClassName}` : ""}`}
                        forcePage={offset}
                        nextLabel={
                            <span>
                                <img
                                    alt="next"
                                    aria-label="right-arrow"
                                    className="labels"
                                    src={RightArrow}
                                    tabIndex={0}
                                />
                            </span>
                        }
                        pageCount={Math.ceil(totalCount / rowsPerPage)}
                        previousLabel={
                            <span>
                                <img
                                    alt="previous"
                                    aria-label="left-arrow"
                                    className="labels flip"
                                    src={RightArrow}
                                    tabIndex={0}
                                />
                            </span>
                        }
                        onPageChange={(val): void => {
                            changeOffset(val.selected);
                            if (handlePagination) {
                                handlePagination(val);
                            }
                        }}
                        {...{
                            breakClassName,
                            breakLinkClassName,
                            disabledClassName,
                            marginPagesDisplayed,
                            nextClassName,
                            nextLinkClassName,
                            pageClassName,
                            pageLinkClassName,
                            pageRangeDisplayed,
                            previousClassName,
                            previousLinkClassName
                        }}
                    />
                </ReactPaginateStyle>
            </TableFooterPaginationStyles>
        );
    }

    return null;
};

PaginationComponent.defaultProps = {
    activeClassName: "active",
    containerClassName: "pagination my-0",
    initialPageIndex: 0,
    marginPagesDisplayed: 2,
    pageRangeDisplayed: 5,
    rowsPerPage: 10,
    selectedCount: 0,
    totalCount: 0
};
